import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  category: "",
  mainLanguage: "",
  dateRange: "",
  search: "",
  languages: {
    JavaScript: false,
    HTML: false,
    CSS: false,
    Python: false,
    React: false,
    TypeScript: false,
  },
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setCategory(state, action) {
      state.category = action.payload;
    },
    setLanguage(state, action) {
      state.mainLanguage = action.payload;
    },
    setDateRange(state, action) {
      state.dateRange = action.payload;
    },
    setSearch(state, action) {
      state.search = action.payload;
    },
    toggleLanguages(state, action) {
      const language = action.payload;
      state.languages[language] = !state.languages[language];
    },
    applyFilters(state) {
      state.applied = {
        category: state.category,
        mainLanguage: state.mainLanguage,
        dateRange: state.dateRange,
        search: state.search,
        languages: { ...state.languages },
      };
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const {
  setCategory,
  setDateRange,
  setLanguage,
  setSearch,
  toggleLanguages,
  applyFilters,
  resetFilters,
} = filtersSlice.actions;

export default filtersSlice.reducer;
